import { PatientLogin } from "@main/users";

export interface Squad {
    id: string;
    name: string;
    notes: string;
    companyId: number;
    type: SquadType;
    archived: boolean;
}

export enum SquadType {
    UserDefined = 0,
    Athletes = 1,
    Staff = 2,
    UnassignedPatients = 3
}

export interface PlayersAssignment {
    assignedPatients: PatientLogin[];
    unassignedPatients: PatientLogin[];
}